import React from 'react';
import {Link} from 'react-router';

import {NoDataMsg} from '@albert-io/atomic';

import sessionStore from 'client/Session/SessionStore';
// @ts-ignore
import folderIcon from 'client/components/PracticeView/StagingDetails/folder-open.svg';

import TitleBar from 'components/PracticeView/TitleBar/TitleBar.react';

interface Props {
  titlebarBackButton: React.ReactElement;
}

const FolderPracticeViewEmptyState = ({titlebarBackButton}: Props) => {
  return (
    <>
      <TitleBar
        className='folder-practice-view__title-bar--not-found u-color_blue-500'
        imgHref={folderIcon}
        title='Folder not found'
        backButton={titlebarBackButton}
      />
      <NoDataMsg.Container
        className='u-mar_auto u-pad-lr_2 folder-practice-view__no-folder-found'
        centered
      >
        {sessionStore.isStudent() ? (
          <NoDataMsg.Body>
            Students cannot access folders. To view these questions, your teacher must assign them.
          </NoDataMsg.Body>
        ) : (
          <>
            <NoDataMsg.Body>
              The folder you are looking for was not found. The folder may have been deleted by its
              creator, or you may have an invalid link.
            </NoDataMsg.Body>
            <NoDataMsg.Button
              as={Link}
              label='Back to folders list'
              to='/saved'
              color='secondary'
              variant='text'
            >
              View my folders
            </NoDataMsg.Button>
          </>
        )}
      </NoDataMsg.Container>
    </>
  );
};

export default FolderPracticeViewEmptyState;
